module.exports = __webpack_public_path__ + "img/ARS.f99f4be9.svg";